<template>
  <g>
    <path d="M10 25.5v-3h28v3Z" />
  </g>
</template>
